import React, { useEffect } from "react";
import Footer from "./Footer";
import { CircleX } from "lucide-react";

const ExceedMaxRetry = ({ uiConfig }) => {
  useEffect(() => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          status: "fail",
          message: "Exceeded maximum retry limit",
        })
      );
    }

    if (window.flutter_inappwebview) {
      window.flutter_inappwebview.callHandler(
        "KenalFlutterWebViewChannel",
        JSON.stringify({
          status: "fail",
          message: "Exceeded maximum retry limit",
        })
      );
    }
  }, []);
  // Safe access
  const global = uiConfig?.Global || {};
  const cardBgColor = global?.card?.backgroundColor || "#f3f4f6"; // gray-50
  const cardOpacity = global?.card?.opacity || "1"; // default opacity
  const pageBgColor = global?.pageContainer?.backgroundColor || "#ffffff"; // white
  const textColor = global?.text?.fontColor || "#6b7280"; // default gray-500
  return (
    <div
      style={{
        background: pageBgColor,
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        padding: "1rem",
        height: "100%",
      }}
    >
      <div
        style={{
          background: cardBgColor,
          opacity: cardOpacity,
          borderRadius: "0.75rem",
          padding: "2rem",
          marginBottom: "2rem",
        }}
      >
        <div className="flex flex-col">
          <p className="text-2xl font-medium">Exceeded Maximum Retry Limit</p>
          <p className="text-gray-500 text-md mt-4">You have exceeded the maximum retry limit. Please start over.</p>
        </div>
        <div className="flex flex-col items-center mt-8">
          <CircleX height="72" width="72" color="red" />
        </div>
      </div>

      <div className="flex flex-1" />

      <Footer
        style={{
          fontSize: "0.75rem",
          color: textColor,
          marginTop: "1rem",
        }}
      />
    </div>
  );
};

export default ExceedMaxRetry;
